/* eslint-disable eqeqeq */

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Box, Paper } from "@mui/material";
import "./WmsDashboard.css";
import { useEffect, useState } from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import { Typography } from "@mui/material";
import AccordianWrap from "./processComponent/AccordianWrap";
import { WMSDashBoard_Summary_GETROW } from "../../Server/ApiV2";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { vRdxUserInfo } from "../../Redux/roStore";
import DashBoardBreadCrumbs from "./processComponent/DashBoardBreadCrumbs";

export default function WmsDashboard() {
  const [summaryRow, setSummaryRow] = useState([]);

  const GetSummary = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vObj = {
      v_UserCd: vRdxUserInfoObj.UserID,
      v_UserGrp: vRdxUserInfoObj.UserGroupCode,
    };
    const Resp = await WMSDashBoard_Summary_GETROW(
      fcheck_null_undefine_replace_empty(vObj)
    );
    if (Resp?.status === 200) {
      // Convert flat array to grouped object

      setSummaryRow(Resp?.data?.ResultSet);

      return Resp?.data?.ResultSet;
    } else {
      return {};
    }
  };
  const fLoad = async (e) => {
    await GetSummary();
  };
  useEffect(() => {
    fLoad();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <DashBoardBreadCrumbs />
      </div>

      {Object.entries(summaryRow).map(([key, value]) => (
        <Box key={key} mb={2}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, color: "#1976d2" }}
            >
              {key.replace(/([A-Z])/g, " $1").trim()} ({value?.length || 0})
            </Typography>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, color: "#1976d2" }}
            >
              {key == "PendingInbound" && (
                <RefreshIcon
                  onClick={() => {
                    GetSummary();
                  }}
                />
              )}
            </Typography>
          </Box>

          <Paper
            elevation={3}
            sx={{ borderRadius: 2, p: 0, backgroundColor: "#f5faff" }}
          >
            <AccordianWrap headerList={value} GetSummary={GetSummary} />
          </Paper>
        </Box>
      ))}
    </div>
  );
}
